import { isMobile } from '@/utils';

const IdentityAuth = isMobile()
  ? require('./IdentityAuth').default
  : require('./WebIdentityAuth').default;

export * from './IdentityAuth';
export default IdentityAuth;
